module.exports = __webpack_public_path__ + "img/bgcJu@2x.0c44f6c0.png";